import { PriorityHigh, KeyboardDoubleArrowDown } from '@mui/icons-material'
import { Tooltip, Stack, Typography } from '@mui/material'
import { t } from 'i18next'
import React from 'react'

type ScheduleTableErrorProps = {
  isSelected: boolean
}

const ScheduleTableError = ({ isSelected }: ScheduleTableErrorProps) => {
  return (
    <Tooltip
      title={
        <Stack alignItems={'center'}>
          <Typography fontWeight={700}>{t('page.schedule.mismatchedTooltipTitle')}</Typography>
          <Typography textAlign="center" variant="caption">
            {t('page.schedule.mismatchedTooltipContent')}
          </Typography>
          <Typography textAlign="center" variant="caption" pt={1}>
            {t('page.schedule.mismatchedTooltipACtionDescription')}
          </Typography>
        </Stack>
      }
    >
      <Stack direction="row" gap={0.5} alignItems="center">
        <Stack
          sx={{
            width: 16,
            height: 16,
            borderRadius: 36,
            bgcolor: isSelected ? 'black' : 'warning.main',
            justifyContent: 'center',
            alignItems: 'center',
            transition: 'all 150ms ease-in-out',
          }}
        >
          <PriorityHigh
            sx={{
              width: 12,
              height: 12,
              color: isSelected ? 'primary.main' : 'background.elevation9',
              transition: 'all 150ms ease-in-out',
            }}
          />
        </Stack>
        <KeyboardDoubleArrowDown
          className="dropdown-error-icon"
          sx={{
            width: 16,
            height: 16,
            color: isSelected ? 'black' : 'warning.main',
            transition: 'all 150ms ease-in-out',
            opacity: 1,
            visibility: 'visible'
          }}
        />
      </Stack>
    </Tooltip>
  )
}

export default ScheduleTableError
